/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { useContext, useMemo } from 'react';
import { ObjectDropdown } from '../dropdowns/objectDropdown';
import { selectDIL } from 'srs-middleware';
import { WorkspaceContext } from "views/workspace/workspaceContext";
import { WorkspaceActionCreator } from "hooks/useWorkspaceState";
import { SlykitContext } from "/slykitContext";
import { selectDilDefinitionByName } from "srs-middleware";

/**
 * Simple component for selecting a DIL.
 *
 * @returns {*}
 * @constructor
 */
export const DatasetSelector = () => {
  const {state: {savedStates}} = useContext(SlykitContext);
  const {state: {explorer: {selectedDefinitionName}}, dispatch} = useContext(WorkspaceContext);
  const DIL = selectDIL();
  const DILOptions = DIL ? Object.values(DIL) : [];

  const selectedDefinition = useMemo(() => {
    return selectDilDefinitionByName(selectedDefinitionName);
  }, [selectedDefinitionName]);

  const onSelect = (e) => {
    dispatch(WorkspaceActionCreator.updateSelectedDefinition(e, savedStates));
  }

  return (
    <div css={selector}>
      <ObjectDropdown
        options={DILOptions}
        onSelectionChanged={onSelect}
        activeItem={selectedDefinition}
        optionToString={x => (x ? x.name : '')}
        emptyText={'Select a definition'}
        cy-test='dataset-selector'
      />
    </div>
  );
};

const selector = css`
  display: flex;
  flex: 0 0 auto;
  flex-flow: row;
`;
